export const LogoStone = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    className="w-[92px] h-[28px] fill-current"
    width="1046"
    height="280"
    viewBox="0 0 1046 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.75993 196.419H60.8246C63.0313 216.321 78.5094 228.697 101.513 228.697C120.53 228.697 133.791 219.412 133.791 207.026C133.791 161.476 13.9428 206.141 13.9428 112.388C13.9428 73.0317 47.9904 45.167 93.5398 45.167C147.052 45.167 183.317 73.9164 185.524 117.696H132.011C129.357 98.6793 112.109 88.5097 95.3094 88.5097C78.5094 88.5097 66.1228 96.025 66.1228 110.181C66.1228 155.731 188.178 103.988 188.178 204.819C188.178 247.277 153.683 275.131 101.503 275.131C49.3228 275.131 9.9562 244.612 7.74951 196.419L7.75993 196.419Z"
      fill="#00461E"
    />
    <path
      d="M1032.91 195.971C1024.07 244.175 981.618 275.131 926.774 275.131C851.153 275.131 812.234 215.873 812.234 159.707C812.234 103.54 846.729 45.167 922.35 45.167C997.971 45.167 1032.47 103.103 1032.47 153.951C1032.47 162.351 1032.03 168.981 1031.58 173.853H871.492C875.916 205.246 895.818 224.711 926.774 224.711C951.537 224.711 967.899 214.978 972.76 195.961H1032.9L1032.91 195.971ZM872.377 134.944H970.991C969.221 110.181 951.974 90.2793 922.35 90.2793C894.485 90.2793 877.685 103.988 872.377 134.944Z"
      fill="#00461E"
    />
    <path
      d="M688.284 45.1773C611.217 45.1773 583.477 95.4315 583.477 142.428V271.603H645.389V111.232C645.389 105.029 650.417 100.001 656.621 100.001H719.959C726.163 100.001 731.19 105.029 731.19 111.232V271.603H793.102V142.428C793.102 95.4315 765.362 45.1772 688.295 45.1772L688.284 45.1773Z"
      fill="#00461E"
    />
    <path
      d="M329.218 48.7163H269.513V3.80176H208.048V190.663C208.048 242.405 241.211 271.592 292.516 271.592H329.218V219.849L280.89 219.579C274.686 219.579 269.658 214.551 269.658 208.347L269.513 100.001H329.218V48.7058V48.7163Z"
      fill="#00461E"
    />
    <path
      d="M450.014 232.986L385.197 168.17C380.857 163.829 380.826 156.834 385.062 152.431L337.327 137.307C335.183 147.914 334.485 159.051 335.495 170.501C340.429 226.678 386.322 271.426 442.603 274.965C474.423 276.964 503.661 265.993 525.572 246.861C526.561 245.997 525.499 244.446 524.354 245.06C517.058 248.995 506.982 252.263 493.669 252.263C468.125 252.263 450.014 232.996 450.014 232.996V232.986Z"
      fill="#00461E"
    />
    <path
      d="M450.014 45.2295C421.046 45.2295 394.597 55.9507 374.383 73.6355C373.404 74.489 374.476 76.0399 375.621 75.4154C382.928 71.4704 393.025 68.1812 406.369 68.1812C433.162 68.1812 450.014 87.4377 450.014 87.4377L514.83 152.254C519.212 156.636 519.223 163.746 514.851 168.138L562.128 185.656C563.981 177.464 564.991 168.96 564.991 160.206C564.991 96.7016 513.508 45.2295 450.014 45.2295Z"
      fill="#00461E"
    />
    <path
      d="M385.062 152.431L385.139 152.352L437.081 100.357C437.081 100.357 420.25 81.1348 393.492 81.1348C330.4 81.1348 335.161 165.445 335.161 165.445"
      fill="url(#paint0_linear_1052_5323)"
    />
    <path
      d="M514.852 168.135L514.775 168.214L462.827 220.202C462.827 220.202 479.658 239.424 506.417 239.424C569.509 239.424 564.747 155.114 564.747 155.114"
      fill="url(#paint1_linear_1052_5323)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1052_5323"
        x1="415.573"
        y1="79.1896"
        x2="357.159"
        y2="137.604"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.04917" stopColor="#00461E" stopOpacity="0" />
        <stop offset="0.24295" stopColor="#00461E" stopOpacity="0.32294" />
        <stop offset="0.58068" stopColor="#00461E" stopOpacity="0.81351" />
        <stop offset="0.76356" stopColor="#00461E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_5323"
        x1="484.338"
        y1="241.373"
        x2="541.817"
        y2="183.894"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.04917" stopColor="#00461E" stopOpacity="0" />
        <stop offset="0.24214" stopColor="#00461E" stopOpacity="0.32294" />
        <stop offset="0.57846" stopColor="#00461E" stopOpacity="0.81351" />
        <stop offset="0.76057" stopColor="#00461E" />
      </linearGradient>
    </defs>
  </svg>
);
